import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/httpClient';
import './queryMeta';
import { formatApiError } from './queryMeta';
import { toast } from './toast';

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status === 401) return false;
  return failureCount < 3;
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      const { meta } = mutation;
      if (meta?.silent || !meta?.successMessage) return;
      toast.success(meta.successMessage);
    },
    onError: (error, _variables, _context, mutation) => {
      const { meta } = mutation;
      if (meta?.silent) return;
      toast.error(meta?.errorMessage ?? formatApiError(error));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
  },
});
